import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("polyline", {
  points: "3,20 3,12 13,12 13,20 "
}), ___EmotionJSX("path", {
  d: "M22,20h-4c2.7-3.3,4-5.3,4-6c0-1-1-2-2-2c-1,0-2,1-2,2"
}), ___EmotionJSX("polyline", {
  points: "13,4 13,12 3,12 3,4 "
}));
export default SVG;